// extracted by mini-css-extract-plugin
export default {"imageContainer":"Y0-z","summaryPar":"Z0-z","ratingCategories":"_0-z","reviewerInfo":"a1-z","reviewTypes":"b1-z","expanded":"c1-z"};